function addToWishlist(event, customerId, productId, emptySrc, fullSrc, current) {
  event.preventDefault();
  if (!customerId) {
    if (!document.querySelector('#favorite-tooltip')) return false;
    document.querySelector('#favorite-tooltip').innerHTML = `
      <svg class="cursor-pointer w-[12px] absolute top-[15px] right-[15px]" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" onClick="closeTooltip()">
        <rect x="3.76562" y="0.255859" width="27.201" height="4.6033" transform="rotate(45 3.76562 0.255859)" fill="#02040F"/>
        <rect x="23" y="3.51074" width="27.201" height="4.6033" transform="rotate(135 23 3.51074)" fill="#02040F"/>
      </svg>
      <span class="text-h4 text-highlight_dark mb-4 font-bold font-Cotta">
          Product toevoegen aan je verlanglijstje?
        </span>
        <span class="text-[14px] text-black">
          Maak snel en gratis een account aan of log in om dit product toe te voegen aan je verlanglijstje. Deel vervolgens eenvoudig met je partner, familie en/of vrienden.
        </span>
        <div class="flex items-center space-x-8 mt-[20px]">
          <a id="register-link" href="#" class="bg-highlight_light text-bright px-6 py-2 rounded-full flex space-x-2 items-center hover:bg-highlight_dark transition-all">
            <span>Maak een account aan</span>
          </a>
          <a id="login-link" class="underline text-intense" href="#">Ik wil inloggen</a>
        </div>   
    `;

    setTooltipLinks();

    document.querySelector('#favorite-tooltip').classList.remove('translate-x-[200%]');
    document.querySelector('#favorite-tooltip').classList.add('translate-x-[0%]');
  } else {
    const pId = `gid://shopify/Product/${productId}`;
    const cId = `${customerId}`;

    fetch('https://hook.eu2.make.com/pxc1bye5bo7nbbywsxeowgnsg7bzdal2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: pId,
        customerId: cId,
        method: 'add',
      }),
    })
      .then((response) => response.text())
      .then((data) => {
        if (data == 'Accepted') {
          if (!document.querySelector('#favorite-tooltip')) return false;

          document.querySelector('#favorite-tooltip').innerHTML = `Product toegevoegd aan verlanglijstje`;
          document.querySelector('#favorite-tooltip').classList.remove('translate-x-[200%]');
          document.querySelector('#favorite-tooltip').classList.add('translate-x-[0%]');

          setTimeout(() => {
            document.querySelector('#favorite-tooltip').classList.add('translate-x-[200%]');
            document.querySelector('#favorite-tooltip').classList.remove('translate-x-[0%]');
          }, 3000);

          console.log(current.src);
          current.src = fullSrc;

          return data;
        } else {
          return data;
        }
      })
      .catch((error) => {
        console.error('Error:', error);

        if (!document.querySelector('#favorite-tooltip')) return false;

        document.querySelector('#favorite-tooltip').innerHTML = `Er is iets misgegaan.`;
        document.querySelector('#favorite-tooltip').classList.remove('translate-x-[200%]');
        document.querySelector('#favorite-tooltip').classList.add('translate-x-[0%]');

        setTimeout(() => {
          document.querySelector('#favorite-tooltip').classList.add('translate-x-[200%]');
          document.querySelector('#favorite-tooltip').classList.remove('translate-x-[0%]');
        }, 3000);
      });
  }
}

function removeFromWishlist(event, customerId, productId, emptySrc, fullSrc, current) {
  event.preventDefault();
  const pId = `gid://shopify/Product/${productId}`;
  const cId = `${customerId}`;

  fetch('https://hook.eu2.make.com/pxc1bye5bo7nbbywsxeowgnsg7bzdal2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      productId: pId,
      customerId: cId,
      method: 'delete',
    }),
  })
    .then((response) => response.text())
    .then((data) => {
      if (data == 'Accepted') {
        if (!document.querySelector('#favorite-tooltip')) return false;

        document.querySelector('#favorite-tooltip').innerHTML = `Product succesvol verwijderd van verlanglijstje`;
        document.querySelector('#favorite-tooltip').classList.remove('translate-x-[200%]');
        document.querySelector('#favorite-tooltip').classList.add('translate-x-[0%]');

        setTimeout(() => {
          document.querySelector('#favorite-tooltip').classList.add('translate-x-[200%]');
          document.querySelector('#favorite-tooltip').classList.remove('translate-x-[0%]');
        }, 3000);

        console.log(current.src);
        current.src = emptySrc;
      }
    })
    .catch((error) => {
      console.error('Error:', error);

      if (!document.querySelector('#favorite-tooltip')) return false;

      document.querySelector('#favorite-tooltip').innerHTML = `Er is iets misgegaan.`;
      document.querySelector('#favorite-tooltip').classList.remove('translate-x-[200%]');
      document.querySelector('#favorite-tooltip').classList.add('translate-x-[0%]');

      setTimeout(() => {
        document.querySelector('#favorite-tooltip').classList.add('translate-x-[200%]');
        document.querySelector('#favorite-tooltip').classList.remove('translate-x-[0%]');
      }, 3000);
    });
}

function closeTooltip() {
  document.querySelector('#favorite-tooltip').classList.add('translate-x-[200%]');
  document.querySelector('#favorite-tooltip').classList.remove('translate-x-[0%]');
}

function setTooltipLinks() {
  // Get the current URL encoded
  var currentUrl = encodeURIComponent(window.location.pathname + window.location.search);

  if (!document.querySelector('#favorite-tooltip #login-link')) return false;

  // Set the href attribute of the login link with the current URL
  document
    .querySelector('#favorite-tooltip #login-link')
    .setAttribute('href', '/account/login?return_url=' + currentUrl);
  document
    .querySelector('#favorite-tooltip #register-link')
    .setAttribute('href', '/account/register?return_url=' + currentUrl);
}

window.addEventListener('load', function () {
  setTooltipLinks();
});
